import React, { useEffect, useState } from 'react'
import { Radio, Select, SelectMobile, ToolTip } from 'zati-ui-web'
import { requestFactors } from './handleFactorConfig'
import Trial from '@src/utils/trial'
import { ModalMethod } from '@src/components/common/modal-method'
import { formatPrice, isPC, ageToDate, sessionStorage } from '@src/utils'
import { calculatePremium, premiumForLiability, getUserInfo, getCuid } from '@src/api'
import { getSARangeByAge, resetSAValue } from './handleSARange'
import { getPromitionId, getPromitionCode } from './handlePromotionCode'
import InputNumberBar from '@src/components/common/input-number-bar'
import { connect } from '@src/mirrorx'

import 'zati-ui-web/lib/Radio/index.scss'
import 'zati-ui-web/lib/Select/index.scss'
import 'zati-ui-web/lib/SelectMobile/index.scss'
import 'zati-ui-web/lib/ZaSlider/index.scss'
import 'zati-ui-web/lib/ToolTip/index.scss'
import style from './index.module.scss'
import './index.scss'

const Title = (props) => (
  <div className={style.title}>
    {props.title}
    {props.toolTip && (
      <ToolTip placement='bottom' overlay={props.toolTip}>
        <i className='iconcomment iconfont ml5' />
      </ToolTip>
    )}
  </div>
)

const RadioBox = (props) => {
  const { value, defaultOptions = [], title, onChange } = props

  const handleChange = (e) => {
    const val = e.target.value
    typeof onChange === 'function' && onChange(val)
  }

  return (
    <div className={style.radioContainer}>
      <Title title={title} />
      <Radio.Group value={value}>
        {defaultOptions.map(({ customizeText, customizeValue }, index) => (
          <Radio.Button
            className={style.radioButton}
            key={index}
            label={customizeText}
            value={customizeValue}
            onChange={handleChange}
          />
        ))}
      </Radio.Group>
    </div>
  )
}

const SelectBox = (props) => {
  const SelectComp = isPC() ? Select : SelectMobile 
  const { Option: SelectOption } = SelectComp

  const { value, defaultOptions, title, onChange, toolTip } = props

  const handleChange = (val) => {
    typeof onChange === 'function' && onChange(val)
  }

  return (
    <div className={style.selectContainer}>
      <Title title={title} toolTip={toolTip} />
      <SelectComp className={style.select} value={value} placeholder='請選擇' onChange={handleChange}>
        {defaultOptions.map(({ customizeValue, customizeText }, index) => (
          <SelectOption key={index} value={customizeValue} title={customizeText}>
            {customizeText}
          </SelectOption>
        ))}
      </SelectComp>
    </div>
  )
}

// 性别
const GenderCheckBox = (props) => {
  const { customizeCode, value, title, defaultOptions, onChange } = props

  const handleChange = (val) => {
    onChange({
      [customizeCode]: val
    })
  }

  return <RadioBox title={title} onChange={handleChange} value={value} defaultOptions={defaultOptions} />
}

// 吸烟状态
const SmokingCheckBox = (props) => {
  const { customizeCode, value, title, defaultOptions, onChange } = props

  const handleChange = (val) => {
    onChange({
      [customizeCode]: val
    })
  }

  return <RadioBox title={title} onChange={handleChange} value={value} defaultOptions={defaultOptions} />
}

// 年龄
const AgeCheckBox = (props) => {
  const { value, title, defaultOptions, onChange, toolTip } = props

  const handleChange = (val) => {
    onChange(val)
  }

  return (
    <SelectBox title={title} toolTip={toolTip} onChange={handleChange} value={String(value)} defaultOptions={defaultOptions} />
  )
}

// 保单保障期
const PeriodCheckBox = (props) => {
  const { customizeCode, value, title, defaultOptions, onChange, toolTip } = props

  const handleChange = (val) => {
    onChange({
      [customizeCode]: val
    })
  }

  return (
    <SelectBox title={title} toolTip={toolTip} onChange={handleChange} value={value} defaultOptions={defaultOptions} />
  )
}

// 保额
const SACheckBox = (props) => {
  const {
    minValue,
    maxValue,
    step,
    value,
    title,
    customizeCode,
    // onChange,
    onAfterChange
  } = props

  // const handleChange = (val) => {
  //   typeof onChange === 'function' && onChange({
  //     [customizeCode]: val
  //   })
  // }

  const handleAfterChange = (val) => {
    typeof onAfterChange === 'function' &&
      onAfterChange({
        [customizeCode]: val
      })
  }

  return (
    <div className={style.sliderContainer}>
      <Title title={title} />
      <InputNumberBar
        inputDisabled
        prefix='HK$ '
        formatFn={formatPrice}
        min={Number(minValue)}
        max={Number(maxValue)}
        value={Number(value)}
        step={Number(step)}
        onChange={handleAfterChange}
      />
    </div>
  )
}

// 预估保费
const EstimatedPremium = (props) => {
  const { payFrequencyType, t, premiumInfo } = props
  const [payFrequencyText, setPayFrequencyText] = useState()

  useEffect(() => {
    const text = transferTypeToText(payFrequencyType)
    setPayFrequencyText(text)
  }, [payFrequencyType])

  function transferTypeToText(type) {
    const paymentFrequencyMap = {
      1: '',
      2: t('anan_resp_quotation_per_year') || 'year',
      3: t('anan_resp_quotation_per_halfyear') || 'half-year',
      4: t('anan_resp_quotation_per_quarter') || 'quarter',
      5: t('anan_resp_quotation_per_month') || 'month',
      6: t('anan_resp_quotation_per_day') || 'day',
      10: '' // N年缴。先放在这里
    }
    return type && paymentFrequencyMap[type.slice(0, 1)]
  }

  return (
    <div>
      <Title title={t('anan_ed_quotation_estimate_premium_title')} />
      <div className={style.premiumWrapper}>
        <div className={style.hightLightPrice}>
          HK$ {formatPrice(premiumInfo.valueDiscount || premiumInfo.totalPrice)}/{payFrequencyText}
        </div>
        <div className={style.originPrice}>
          HK$ {formatPrice(premiumInfo.totalPrice)}/{payFrequencyText}
        </div>
      </div>
    </div>
  )
}

// 试算器
const EdigestQuotation = (props) => {
  const { t, productPlan, onChangeFactors, channel } = props
  const { goodsId, planId } = productPlan
  const [factorConfig, setFactorConfig] = useState({})
  const [products, setProducts] = useState()
  const [factorParam, setFactorParam] = useState({})
  const [premiumInfo, setPremiumInfo] = useState({})

  useEffect(() => {
    goodsId && planId && init()
  }, [productPlan])

  async function init() {
    setProducts(props?.productPlan?.products)
    const factorParam = await initfactorConfig()
    factorParam && (await initPremium(factorParam))
  }

  // 初始化获取试算器配置
  async function initfactorConfig() {
    const config = await requestFactors({ goodsId, planId }, t)
    if (config) {
      setFactorConfig(config)
      const promotionCode = await getPromitionCode(channel)

      const factorParam = {
        SA: config.SA?.defaultValue,
        gender: config.gender?.defaultValue,
        payFrequencyType: config.payFrequencyType?.defaultValue,
        paymentPeriod: config.paymentPeriod?.defaultValue,
        smoking: config.smoking?.defaultValue,
        age: config.age?.defaultValue,
        promotionCode,
      }
      setFactorParam(factorParam)
      return factorParam
    }
  }

  // 初始化预估保费
  async function initPremium(factorParam) {
    const products = props?.productPlan?.products
    typeof onChangeFactors === 'function' && onChangeFactors(handleAgetoBirthday(factorParam))
    await getPremium(factorParam, products)
  }

  // 接口入参将age替换成birthday
  function handleAgetoBirthday(factorParam) {
    const params = {
      ...factorParam,
      birthday: ageToDate(factorParam.age)
    }
    delete params.age
    return params
  }

  function transFromProducts(products) {
    return products &&
    products.map((item) => {
      const obj = {
        ...item,
        liabilities: item.liabilities || item.liabilityList
      }
      delete obj.liabilityList
      return obj
    });
  }

  // 试算保费
  async function getPremium(factorParam, products) {
    const promotionId = await getPromitionId({
      activity: channel,
      goodsId,
      planId,
      payFrequencyType: factorParam.payFrequencyType
    })
    const params = handleAgetoBirthday({
      ...factorParam,
      promotionId,
    })
    delete params.promotionCode

    const premiumInfo =
      (await calculatePremium({
        goodsPlanId: planId,
        goodsId: goodsId,
        factorParams: params,
        optionalLiability: transFromProducts(products)
      })) || {}
    console.log('premiumInfo111:', premiumInfo)
    setPremiumInfo(premiumInfo)
  }

  const changeFactorParams = (params) => {
    const param = {
      ...factorParam,
      ...params
    }
    setFactorParam(param)
    return param
  }

  const changeFactorHandler = async (changeParams) => {
    console.log('changeParams: ', changeParams)

    let productsParam = products || props?.productPlan?.products

    // 修改了保额
    if (Object.keys(changeParams).includes('SA')) {
      productsParam = await premiumForLiability({
        goodsId: goodsId,
        goodsPlanId: planId,
        sa: changeParams.SA,
        productId: products && products[0].productId
      })
      setProducts(productsParam)
    }

    console.log('productsParam: ', productsParam);
    const param = changeFactorParams(changeParams)
    typeof onChangeFactors === 'function' && onChangeFactors(handleAgetoBirthday(param))
    await getPremium(param, productsParam)
  }

  // 修改年龄会影响保额范围
  async function changeAgeHandler(val) {
    const SAConfig = await changeSARange(val)

    let params = {
      age: val
    }

    // 保额有改变
    if (SAConfig.defaultValue !== factorParam.SA) {
      params = {
        age: val,
        SA: SAConfig.defaultValue
      }
    }

    await changeFactorHandler(params)
  }

  // 修改保额范围
  async function changeSARange(val) {
    const rangeObj = await getSARangeByAge(goodsId, planId, val)
    console.log('rangeObj: ', rangeObj)
    if (!rangeObj) return

    const { minSA, maxSA } = rangeObj || {}

    const SAConfig = {
      ...factorConfig.SA,
      minValue: minSA,
      maxValue: maxSA,
      defaultValue: resetSAValue(factorParam.SA, minSA, maxSA)
    }

    const newFactorConfig = {
      ...factorConfig,
      SA: SAConfig
    }
    setFactorConfig(newFactorConfig)

    return SAConfig
  }

  // 检查是否在香港
  async function checkIsInHk() {
    const inHK = await Trial.isInHk()
    if (!inHK) {
      const reason = t('anan_resp_quotation_not_in_HK_tips') || 'Apologies as you are currently not located in Hong Kong. As per regulation, our products can only be offered to applicants in Hong Kong. Please visit us again next time you are in Hong Kong.'
      ModalMethod({
        t: t,
        content: <div>{reason}</div>
      })
    }
    return inHK
  }

  // 检查是否已登陆
  async function checkIsLogin() {
    const { zafamUser } = props
    const res = await getUserInfo()
    const zafamIsLogin = zafamUser?.isLogin
    return (res?.success && res?.value && res?.value?.isLogin) || zafamIsLogin
  }

  // 拼接投保流程页需要的入参
  async function encodeInsurePageUrl({goodsId, planId, packageId, promoCode, channel, factorParam }) {
    const idRes = await getCuid()
    const cuid = idRes?.value?.fileKey
    const factors = handleAgetoBirthday(factorParam)

    // sessionStorage.set('calculateVals', factors)
    Trial.saveCalItems(factors, goodsId)
    const insurePageUrl = `/insure-declaration?cuid=${cuid}&goodsId=${goodsId}&goodsPlanId=${planId}&packageId=${packageId}&pcode=${promoCode}&channel=${channel}`
    return insurePageUrl
  }

  // 拼接产品详情页需要的入参
  function encodeProductDetailUrl({goodsId, factorParam, backUrl, promoCode, channel}) {
    const factors = handleAgetoBirthday(factorParam)
    // sessionStorage.set('calculateVals', factors)
    Trial.saveCalItems(factors, goodsId)
    const productdetailUrl = `/productdetail?showLogin=1&goodsId=${goodsId}&pcode=${promoCode}&backUrl=${encodeURIComponent(backUrl)}&channel=${channel}`
    return productdetailUrl
  }

  // 点击“立即投保”按钮
  async function toInsure() {
    const isInHk = await checkIsInHk()

    if (!isInHk) return;

    // 预估保费页需要使用到products
    sessionStorage.set(`productListParams-${planId}`, JSON.stringify(transFromProducts(products)))

    const insurePageUrl = await encodeInsurePageUrl({
      channel,
      goodsId,
      planId,
      factorParam,
      promoCode: factorParam.promotionCode,
      packageId: props?.productPlan?.productPackageId
    })

    const productdetailUrl = encodeProductDetailUrl({
      channel,
      goodsId,
      factorParam,
      backUrl: insurePageUrl,
      promoCode: factorParam.promotionCode,
    })

    const isLogin = await checkIsLogin()
    const url = isLogin ? insurePageUrl : productdetailUrl
    console.log('url: ', url);

    window.open(url, '_parent') // ED要求

  }

  return (
    <>
      <div className={`${style.stepBar}`}>{t('anan_resp_edigest_step_1') || 'Step1: 試算保費'}</div>
      { props.isPc ? 
        <div className={`${style.section}`}>
          <div className={`${style.row} mb20`}>
            <div className={`${style.column}`}>
              {/* 性别 */}
              {factorConfig.gender && (
                <GenderCheckBox {...factorConfig.gender} value={factorParam.gender} onChange={changeFactorHandler} />
              )}
              {/* 吸烟状况 */}
              {factorConfig.smoking && (
                <SmokingCheckBox {...factorConfig.smoking} value={factorParam.smoking} onChange={changeFactorHandler} />
              )}
            </div>
            <div className={`${style.column} ${style.leftAlign}`}>
              {/* 年龄 */}
              {factorConfig.age && (
                <AgeCheckBox {...factorConfig.age} value={factorParam.age} onChange={changeAgeHandler} />
              )}
            </div>
          </div>
          <div className={`${style.row} mb20`}>
            <div className={`${style.column}`}>
              {/* 保额 */}
              {factorConfig.SA && (
                <SACheckBox
                  t={t}
                  {...factorConfig.SA}
                  value={factorParam.SA}
                  onChange={changeFactorParams}
                  onAfterChange={changeFactorHandler}
                  onChangeRange={changeSARange}
                />
              )}
            </div>
            <div className={`${style.column} ${style.leftAlign}`}>
              {/* 保单保障期 */}
              {factorConfig.paymentPeriod && (
                <PeriodCheckBox
                  {...factorConfig.paymentPeriod}
                  value={factorParam.paymentPeriod}
                  onChange={changeFactorHandler}
                />
              )}
            </div>
          </div>
        </div> 
        :
        <div className={`${style.section}`}>
          <div className={`${style.row} mb20`}>
            {/* 性别 */}
            {factorConfig.gender && (
              <GenderCheckBox {...factorConfig.gender} value={factorParam.gender} onChange={changeFactorHandler} />
            )}
            {/* 吸烟状况 */}
            {factorConfig.smoking && (
              <SmokingCheckBox {...factorConfig.smoking} value={factorParam.smoking} onChange={changeFactorHandler} />
            )}
          </div>
          <div className={`${style.row} mb20`}>
            {/* 年龄 */}
            {factorConfig.age && (
              <AgeCheckBox {...factorConfig.age} value={factorParam.age} onChange={changeAgeHandler} />
            )}
            {/* 保单保障期 */}
            {factorConfig.paymentPeriod && (
              <PeriodCheckBox
                {...factorConfig.paymentPeriod}
                value={factorParam.paymentPeriod}
                onChange={changeFactorHandler}
              />
            )}
          </div>
          <div className='mb20'>
            {/* 保额 */}
            {factorConfig.SA && (
              <SACheckBox
                t={t}
                {...factorConfig.SA}
                value={factorParam.SA}
                onChange={changeFactorParams}
                onAfterChange={changeFactorHandler}
                onChangeRange={changeSARange}
              />
            )}
          </div>
        </div> 
      }
      <div className={`${style.stepBar}`}>{t('anan_resp_edigest_step_2') || 'Step2: 登入購買，新用戶註冊換領獎品'}</div>
      <div className={`${style.bottomSection} ${style.row}`}>
        <EstimatedPremium t={t} payFrequencyType={factorParam.payFrequencyType} premiumInfo={premiumInfo} />
        { factorParam && <button className={style.btnWrapper} onClick={toInsure}>{t('anan_resp_edigest_insure') || '立即投保'}</button> }
      </div>
    </>
  )
}


export default connect(state => {
  return {
    zafamUser: state.mainModel.zafamUser
  }
})(EdigestQuotation)
